// extracted by mini-css-extract-plugin
export default {"container":"UserMenu_container__d2ski","buttonContainer":"UserMenu_buttonContainer__zxKz8","buttonCircle":"UserMenu_buttonCircle__aIVmO","opened":"UserMenu_opened__IUUgF"};